import * as types from './types'
import storage from '@/plugins/storage'
export default {
  passthrough: '',
  token: storage.local.getItem(types.SESSION_TOKEN_NAME),
  roles: JSON.parse(storage.local.getItem(types.SESSION_ROLES_NAME)),
  userProfile: JSON.parse(storage.local.getItem(types.SESSION_USER_PROFILE)),
  primaryRole: JSON.parse(storage.local.getItem(types.SESSION_PRIMARY_ROLE)),
  userToken: JSON.parse(storage.local.getItem(types.SESSION_USER_TOKEN)),
  userInfo: null,
  businessUsers: [],
  profile: JSON.parse(storage.session.getItem(types.SESSION_USER_PROFILE)),
  isLogout: false,
  language: storage.local.getItem(types.SESSION_LANGUAGE) || '',
  channelType: storage.local.getItem(types.SESSION_CHANNELTYPE) || 'ServiceRequest',
  languages: [
    {
      name: '',
      value: ''
    },
    {
      name: 'English',
      value: 'en'
    },
    {
      name: 'Spanish',
      value: 'es'
    },
    {
      name: 'French',
      value: 'fr'
    },
    {
      name: 'Italian',
      value: 'it'
    },
    {
      name: 'Dutch',
      value: 'nl'
    },
    {
      name: 'German',
      value: 'de'
    },
    {
      name: 'Protégées',
      value: 'pt'
    },
    {
      name: 'Greek',
      value: 'gr'
    },
    {
      name: 'Norwegian',
      value: 'no'
    },
    {
      name: 'Finnish',
      value: 'fi'
    },
    {
      name: 'Swedish',
      value: 'sv'
    },
    {
      name: 'Slovene',
      value: 'sl'
    },
    {
      name: 'Polish',
      value: 'pl'
    },
    {
      name: 'Croatian',
      value: 'hr'
    },
    {
      name: 'Danish',
      value: 'da'
    },
    {
      name: 'Lithuanian',
      value: 'lt'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js